import React from 'react';

const TermsOfService = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem', color: '#333', lineHeight: '1.6' }}>
      <h1>Terms of Service</h1>
      <p><strong>Effective Date:</strong> July 22, 2026</p>
      <p><strong>Website:</strong> https://synthetica-3bf2d.web.app/</p>

      <hr style={{ margin: '1.5rem 0', borderColor: '#eee' }} />

      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing or using Synthetica ("we," "our," or "us") at https://synthetica-3bf2d.web.app/, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the application.
        </p>
      </section>

      <section>
        <h2>2. Description of Service</h2>
        <p>
          Synthetica provides web-based AI text classification and analysis services. We reserve the right to update, modify, or discontinue any feature or functionality of the platform at any time without prior notice.
        </p>
      </section>

      <section>
        <h2>3. User Accounts and Security</h2>
        <p>
          To access certain features, you may need to register an account using Firebase Authentication. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
        </p>
      </section>

      <section>
        <h2>4. Acceptable Use Policy</h2>
        <p>You agree not to use Synthetica to:</p>
        <ul>
          <li>Violate any local, state, national, or international law or regulation.</li>
          <li>Attempt to reverse-engineer, decompile, or access source code associated with our classification engines and backend APIs.</li>
          <li>Interfere with or disrupt the performance, integrity, or availability of our Firebase database, hosting, or PythonAnywhere backend services.</li>
          <li>Automate requests to our endpoints without explicit authorization.</li>
        </ul>
      </section>

      <section>
        <h2>5. Content Ownership and User Submissions</h2>
        <p>
          You retain all intellectual property rights to the text, essays, and documents you submit to Synthetica for processing. By submitting content, you grant us a limited, temporary license to process, analyze, and output metrics solely to fulfill your requests.
        </p>
      </section>

      <section>
        <h2>6. Accuracy Disclaimer and No Warranties</h2>
        <p>
          Synthetica and its automated analysis algorithms are provided on an <strong>"AS IS"</strong> and <strong>"AS AVAILABLE"</strong> basis. 
        </p>
        <p>
          <strong>We make no guarantees, express or implied, regarding the accuracy, completeness, precision, or reliability of any analysis, score, or classification output by the product.</strong> The outputs are generated by automated statistical models and should not be relied upon as absolute or error-free determinations. You assume full responsibility for any actions taken or decisions made based on the application's results.
        </p>
      </section>

      <section>
        <h2>7. Limitation of Liability</h2>
        <p>
          In no event shall Synthetica or its developers be liable for any indirect, incidental, consequential, special, or punitive damages arising out of or related to your reliance on the product's outputs, or your use of or inability to use the platform.
        </p>
      </section>

      <section>
        <h2>8. Changes to Terms</h2>
        <p>
          We reserve the right to revise these Terms of Service at any time. Continued use of the platform after updates are posted constitutes your acceptance of the revised terms.
        </p>
      </section>

      <section>
        <h2>9. Contact Information</h2>
        <p>
          If you have any questions about these Terms of Service, please reach out via the communication options available on the platform.
        </p>
      </section>
    </div>
  );
};

export default TermsOfService;